import React, { ReactNode } from 'react';

// constants
import Rules from 'restrictions/roles/constants/rules';

// hooks
import useRestrictionRules from 'restrictions/roles/hooks/useRestrictionRules';

// components
import Restricted from 'restrictions/roles/components/Restricted';

interface Props {
  rule: Rules;
  children: ReactNode;
}

const RestrictedByRule = ({ rule, children }: Props) => {
  const { hasRule } = useRestrictionRules();
  return <Restricted isRestricted={hasRule(rule)}>{children}</Restricted>;
};

export default RestrictedByRule;
